import React from "react";
import { useNavigate } from "react-router-dom";
import "./CategoryAccordion.css";

const categories = [
  {
    id: "One",
    title: "Refrigeración Industrial",
    description:
      "Repuestos para refrigeración industrial: calidad, innovación y soluciones efectivas. Encuentra lo necesario.",
    link: "/industrialr",
    icon: "bi-snow",
  },
  {
    id: "Two",
    title: "Refrigeración Doméstica",
    description:
      "Encuentra repuestos para refrigeración doméstica con calidad garantizada. Todo lo que necesitas.",
    link: "/nevera",
    icon: "bi-house-gear",
  },
  {
    id: "Three",
    title: "Lavadoras",
    description:
      "Repuestos para lavadoras de todas las marcas. Soluciones rápidas y efectivas.",
    link: "/lavadora",
    icon: "bi-arrow-repeat",
  },
  {
    id: "Four",
    title: "Cocinas",
    description:
      "Repuestos confiables para cocinas. Mejora su funcionamiento con nuestros productos.",
    link: "/industrialr",
    icon: "bi-fire",
  },
  {
    id: "Five",
    title: "Aire Acondicionado",
    description:
      "Amplia variedad de repuestos para aire acondicionado. Innovación y calidad garantizada.",
    link: "/aireacondicionado",
    icon: "bi-wind",
  },
  {
    id: "Six",
    title: "Instalaciones a Gas",
    description:
      "Amplia variedad de repuestos para instalaciones a gas. Seguridad y calidad garantizadas.",
    link: "/gas",
    icon: "bi-fire",
  },
];

const CategoryAccordion = () => {
  const navigate = useNavigate();

  const irCategoria = (link) => {
    navigate(link);
  };

  return (
    <section className="category-section">
      <div className="category-container">
        {/* =====================================================
            ENCABEZADO
        ===================================================== */}
        <div className="category-header">
          <div>
            <span className="category-kicker">NUESTRO CATÁLOGO</span>

            <h2>Categorías de productos</h2>

            <p>
              Encuentra repuestos, componentes y soluciones para refrigeración,
              climatización y línea blanca.
            </p>
          </div>

          <div className="category-header-line"></div>
        </div>

        {/* =====================================================
            GRID
        ===================================================== */}
        <div
          className="accordion category-accordion"
          id="categoryAccordion"
        >
          <div className="category-grid">
            {categories.map((category, index) => {
              const headingId = `category-heading-${category.id}`;
              const collapseId = `category-collapse-${category.id}`;

              return (
                <article
                  className="category-card"
                  key={category.id}
                >
                  <div className="accordion-item category-accordion-item">
                    <h2
                      className="accordion-header"
                      id={headingId}
                    >
                      <button
                        className="accordion-button collapsed category-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#${collapseId}`}
                        aria-expanded="false"
                        aria-controls={collapseId}
                      >
                        <span className="category-icon">
                          <i className={`bi ${category.icon}`}></i>
                        </span>

                        <span className="category-title">
                          {category.title}
                        </span>

                        <span className="category-number">
                          {String(index + 1).padStart(2, "0")}
                        </span>
                      </button>
                    </h2>

                    <div
                      id={collapseId}
                      className="accordion-collapse collapse"
                      aria-labelledby={headingId}
                      data-bs-parent="#categoryAccordion"
                    >
                      <div className="accordion-body category-body">
                        <p>{category.description}</p>

                        <button
                          type="button"
                          className="category-link"
                          onClick={() => irCategoria(category.link)}
                        >
                          <span>Ver productos</span>

                          <i className="bi bi-arrow-right"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CategoryAccordion;